import React, { useEffect, useState } from 'react'
import './PreviousEvents.scss'
import { UtilService } from 'services/shared/UtilService';
import { msgTypes } from 'constants/msgTypes';
import ApiUrl from 'services/shared/ApiUrl';
import { useNavigate } from 'react-router-dom';

const PreviousEvents = () => {
  const [previousEventList, setPreviousEventList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadPreviousEventList()
  }, [])

  const loadPreviousEventList = async () => {
    const res = await UtilService.getPreviousEventList();

    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setPreviousEventList(res.data)
        //setPreviousEventList([])
      } else {
        setPreviousEventList([])
      }
    }
  }

  const viewGallery = (event) => {
    navigate('/post-event-gallery', { state: { event: event } })
  }

  const PreviousEventList = () => {
    return (
      <>
        {previousEventList.map((event) => {
          return (
            <div className='row p-5 events-up'>
              <div className='col-lg-6 d-flex justify-content-center'>
                <div className='event-img'>
                  {(event.image !== '' && event.image !== undefined && event.image !== null) ? (
                    <img src={ApiUrl.fileBaseUrl + event.image} alt=""
                    style={{
                      width: "350px",   // Fixed width
                      height: "200px",  // Fixed height
                      objectFit: "cover",  // Ensures proper image fit
                      borderRadius: "10px" // Optional: Rounded corners
                    }}
                    ></img>
                  ) : (
                    <img src="/images/events/no_images.png" alt=""></img>
                  )}


                </div>
              </div>
              <div className='col-lg-6'>
                <div className="events-3-holder h-100">
                  <div className="events-3-description-holder">
                    <h3 >{event.eventName}</h3>
                                  <h6 className='p-0 m-0' style={{ fontFamily: 'Arial', fontWeight: 400 }}>
                <span style={{ color: '#030935', fontWeight: '700' }}>Date  </span>  : &nbsp;&nbsp;
                <span style={{ fontWeight: 500 }}>
                  {UtilService.displayEventDate(event.eventStartDate, event.eventEndDate)}
                </span>
              </h6>
              <h6 className='p-0 m-0' style={{ fontFamily: 'Arial', fontWeight: 400 }}>
                <span style={{ color: '#030935', fontWeight: '700' }}>Venue</span> : &nbsp;&nbsp;
                <span style={{ fontWeight: 500 }}>
                  {event.eventVenue}
                </span>
              </h6>
                    {/* <h6>{UtilService.displayEventDate(event.eventStartDate, event.eventEndDate)} {event.eventVenue}</h6> */}
                    <div className="faq-one__btn-box contact-btn d-flex">
                      <button type="submit" disabled={event?.gallery?.length == 0} onClick={() => { viewGallery(event) }} className={event?.gallery?.length > 0 ? "thm-btn faq-one__btn" : "thm-btn faq-one__btn disabled-gallery-button"}>View Gallery<span>
                      </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })
        }
      </>
    )
  }

  return (
    <>
      {/* <!--Page Header Start--> */}
      <section className="page-header past-event-banner member-section">
        {/* <img src="/images/banner/past-event.png"></img> */}
        <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        style={{ width: "100%" }}
                    >
                        <source src="https://www.oneworldnetwork.co/video/1wn-dubai.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
        
        <div className="page-header__bg ">
        </div>
        <div className="container membership-container">
          <div className="page-header__inner membership-head">
         
          </div>
      
        </div>
      </section>
      {/* //   <!--Page Header End--> */}


      <div className='container heading-previous-event'>
        <div className='row'>
          <div className='col-lg-12'>
            <h1 className='upcoming--'>Previous Events</h1>
          </div>
        </div>
      </div>
      <div className='container'>
        {previousEventList.length > 0 ? (
          <PreviousEventList />
        ) : (
          <div className="container">
            <div className="no-gallery mt-0">
              <img src="/images/resources/no-photo-gallery.png" alt="" />
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default PreviousEvents